<template>
    <div v-if="config.visible" class="pop_up_layer" style="display: block" @click=""></div>
    <div v-if="config.visible" class="modal pop_up pop_detail" style="z-index: 99999; display: block; max-width: 640px">
        <button class="close_btn" @click="$emit('close')">
            <img src="img/close.png" alt="닫기" />
        </button>

        <div class="pop_tit">
            <p>서명 작성</p>
        </div>

        <canvas ref="canvas" style="z-index: 99999"></canvas>

        <div class="flex gap-2 mt-2 btn_wrap _default">
            <button class="submit_btn _gray" @click="clear">Clear</button>
            <button class="submit_btn" @click="autoSave">Save</button>
        </div>
    </div>
</template>

<script setup>
    import { ref, watch, onMounted } from "@/BaseComponent";
    import SignaturePad from "signature_pad";

    const props = defineProps({
        config: {
            type: Object,
            required: true,
        },
    });

    const emit = defineEmits(["saved", "close"]);

    const canvas = ref(null);
    let signaturePad = null;

    // 모달 열릴 때마다 캔버스 초기화
    watch(
        () => props.config.visible,
        (visible) => {
            if (visible) {
                setTimeout(() => {
                    const c = canvas.value;
                    c.width = props.config.width || 500;
                    c.height = props.config.height || 300;
                    signaturePad = new SignaturePad(c, {
                        backgroundColor: props.config.backgroundColor || "white",
                        penColor: props.config.penColor || "black",
                    });
                });
            }
        },
    );

    // 서명 지우기
    const clear = () => {
        signaturePad.clear();
    };

    // 자동 저장 (mouseleave)
    const autoSave = () => {
        if (!signaturePad || signaturePad.isEmpty()) return;

        const dataUrl = signaturePad.toDataURL("image/png");

        // Blob 변환 → File
        fetch(dataUrl)
            .then((res) => res.blob())
            .then((blob) => {
                const file = new File([blob], "signature.png", { type: "image/png" });
                emit("saved", { dataUrl, file });
            });
    };
</script>

<style scoped>
    .modal {
        position: fixed;
        /* top: 20%;
        left: 20%; */
        background: white;
        padding: 20px;
        border: 1px solid gray;
    }
    canvas {
        margin-top: 40px;
        border: 1px solid black;
    }
</style>
